import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "paging-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SegmentItemPreview = _resolveComponent("SegmentItemPreview")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.translationSegments, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "segments-container",
        key: item.translationSegmentId
      }, [
        _createVNode(_component_SegmentItemPreview, {
          modelValue: item,
          rowNumber: _ctx.getRowNumber(index)
        }, null, 8, ["modelValue", "rowNumber"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        total: _ctx.paging.rowCount,
        "current-page": _ctx.paging.currentPageNumber,
        "default-page-size": _ctx.paging.pageSize,
        onCurrentChange: _ctx.goToPage
      }, null, 8, ["total", "current-page", "default-page-size", "onCurrentChange"])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}